import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import AdminApp from './admin/AdminApp'
import './styles/globals.css'
import { writeSession } from './utils/safeStorage'

const params      = new URLSearchParams(window.location.search)
const host        = params.get('host') || ''

// Startup, before React mounts: an unguarded throw here is a blank page,
// not a lost preference. See utils/safeStorage.
if (host) writeSession('shopify_host', host)

// The navigation Shopify draws beside the app lives in App.jsx, which knows
// whether onboarding has finished. This file rendered a second copy of it
// outside App and unconditionally, so a seller part-way through setup was shown
// Products, Orders and Listing Rules — every one of which needs the connection
// they had not made yet.

const isAdmin = window.location.pathname.startsWith('/admin')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isAdmin ? (
      <AdminApp />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </React.StrictMode>
)
